import { AutogenModelWirecode, AutogenRowWirecode } from "./autogen/AutogenModelWirecode";

export class ModelWirecode extends AutogenModelWirecode<RowWirecode> {
	constructor() {
		super(RowWirecode);
	}
}

export class RowWirecode extends AutogenRowWirecode {
}